export const WHITE_COLOR = '#FFFFFF';
export const MAIN_PRIMARY_1_COLOR = '#FF4F12';
export const MAIN_PRIMARY_1_COLOR_RGB = '255, 79, 18';
export const GRAYSCALE_91_COLOR = '#E8E8E8';
export const GRAYSCALE_96_COLOR = '#F5F5F5';
export const GRAYSCALE_15_COLOR = '#262626';

export const MAIN_TEXT_COLOR = GRAYSCALE_15_COLOR;
export const ORANGE_COLOR = MAIN_PRIMARY_1_COLOR;
export const ORANGE_COLOR_RGB = MAIN_PRIMARY_1_COLOR_RGB;

export const COLORS = {
  FG: {
    DEFAULT: 'light-dark(#101828, #E8E8EE)',
    SOFT: 'light-dark(#101828BF, #B5B7C0)',
    MUTED: 'light-dark(#1018288C, #9DA1AC)',
    DISABLED: 'light-dark(#10182859, #B5B7C080)',
  },
  BG: {
    SURFACE1: 'light-dark(#FFFFFF, #1B2330)',
    SURFACE2: 'light-dark(#F9F9FA, #262E3D)',
    SURFACE3: 'light-dark(#F4F4F5, #333A48)',
    SURFACE4: 'light-dark(#E8E8EE, #454B59)',
    SURFACE5: 'light-dark(#D3D4DB, #4D525E)',
    DISABLED: 'light-dark(#B5B7C01A, #B5B7C01A)',
    PAGE: 'light-dark(#FFFFFF, #151D2C)',
    PAGE_FILLED: 'light-dark(#F4F4F5, #151D2C)',
    ELEVATED: {
      ZERO: 'light-dark(#FFFFFF, #151D2C)',
      S: 'light-dark(#FFFFFF, #1B2330)',
      M: 'light-dark(#FFFFFF, #262E3D)',
      L: 'light-dark(#FFFFFF, #333A48)',
      XL: 'light-dark(#FFFFFF, #454B59)',
    }
  },
  BORDER: {
    DEFAULT: 'light-dark(#585D6980, #B5B7C080)',
    SOFT: 'light-dark(#585D6940, #B5B7C040)',
    MUTED: 'light-dark(#585D6926, #B5B7C026)',
  },
  ACCENT: {
    DEFAULT: 'light-dark(#FF4F12, #FF4F12)',
    SOFT: 'light-dark(#FF7241, #FF7241)',
    MUTED: 'light-dark(#FFA789, #FFA789)',
    HOVER: 'light-dark(#D9430F, #FFD3C4)',
    ACTIVE: 'light-dark(#B3370D, #FFEDE7)',
    ON_ACCENT: 'light-dark(#FFFFFF, #591C06)',
    CONTAINER_DEFAULT: 'light-dark(#FF4F121A, #FF724133)',
    CONTAINER_SOFT: 'light-dark(#FF4F120D, #FF72411A)',
    CONTAINER_MUTED: 'light-dark(#FF4F1208, #FF72410D)',
    CONTAINER_HOVER: 'light-dark(#FF4F1233, #FF72414D)',
    CONTAINER_ACTIVE: 'light-dark(#FF4F124D, #FF724166)',
    ON_CONTAINER: 'light-dark(#FF4F12, #FFA789)',
  },
  NEUTRAL: {
    DEFAULT: 'light-dark(#585D69, #B5B7C0)',
    SOFT: 'light-dark(#797E8B, #9DA1AC)',
    MUTED: 'light-dark(#B5B7C0, #797E8B)',
    HOVER: 'light-dark(#4D525E, #D3D4DB)',
    ACTIVE: 'light-dark(#454B59, #E8E8EE)',
    ON_NEUTRAL: 'light-dark(#FFFFFF, #151D2C)',
    CONTAINER_DEFAULT: 'light-dark(#585D691A, #797E8B33)',
    CONTAINER_SOFT: 'light-dark(#585D690D, #797E8B1A)',
    CONTAINER_MUTED: 'light-dark(#585D6908, #797E8B0D)',
    CONTAINER_HOVER: 'light-dark(#585D6933, #797E8B4D)',
    CONTAINER_ACTIVE: 'light-dark(#585D694D, #797E8B66)',
    ON_CONTAINER: 'light-dark(#585D69, #B5B7C0)',
  },
  SUCCESS: {
    DEFAULT: 'light-dark(#0ACB5B, #85E5AD)',
    SOFT: 'light-dark(#3BD57C, #60DD94)',
    MUTED: 'light-dark(#85E5AD, #3BD57C)',
    HOVER: 'light-dark(#09AD4D, #C2F2D6)',
    ACTIVE: 'light-dark(#078E40, #E7FAEF)',
    ON_SUCCESS: 'light-dark(#FFFFFF, #044720)',
    CONTAINER_DEFAULT: 'light-dark(#0ACB5B1A, #3BD57C33)',
    CONTAINER_SOFT: 'light-dark(#0ACB5B0D, #3BD57C1A)',
    CONTAINER_MUTED: 'light-dark(#0ACB5B08, #3BD57C0D)',
    CONTAINER_HOVER: 'light-dark(#0ACB5B33, #3BD57C4D)',
    CONTAINER_ACTIVE: 'light-dark(#0ACB5B4D, #3BD57C66)',
    ON_CONTAINER: 'light-dark(#0ACB5B, #85E5AD)',
  },
  WARNING: {
    DEFAULT: 'light-dark(#FDA610, #FED388)',
    SOFT: 'light-dark(#FDB840, #FEC564)',
    MUTED: 'light-dark(#FED388, #FDB840)',
    HOVER: 'light-dark(#D78D0E, #FFE9C3)',
    ACTIVE: 'light-dark(#B1740B, #FFF6E7)',
    ON_WARNING: 'light-dark(#332103, #332103)',
    CONTAINER_DEFAULT: 'light-dark(#FDA6101A, #FDB84033)',
    CONTAINER_SOFT: 'light-dark(#FDA6100D, #FDB8401A)',
    CONTAINER_MUTED: 'light-dark(#FDA61008, #FDB8400D)',
    CONTAINER_HOVER: 'light-dark(#FDA61033, #FDB8404D)',
    CONTAINER_ACTIVE: 'light-dark(#FDA6104D, #FDB84066)',
    ON_CONTAINER: 'light-dark(#D78D0E, #FED388)',
  },
  ERROR: {
    DEFAULT: 'light-dark(#FF2626, #FF9393)',
    SOFT: 'light-dark(#FF5151, #FF7272)',
    MUTED: 'light-dark(#FF9393, #FF5151)',
    HOVER: 'light-dark(#D92020, #FFC9C9)',
    ACTIVE: 'light-dark(#B31B1B, #FFE9E9)',
    ON_ERROR: 'light-dark(#FFFFFF, #590D0D)',
    CONTAINER_DEFAULT: 'light-dark(#FF26261A, #FF515133)',
    CONTAINER_SOFT: 'light-dark(#FF26260D, #FF51511A)',
    CONTAINER_MUTED: 'light-dark(#FF262608, #FF51510D)',
    CONTAINER_HOVER: 'light-dark(#FF262633, #FF51514D)',
    CONTAINER_ACTIVE: 'light-dark(#FF26264D, #FF515166)',
    ON_CONTAINER: 'light-dark(#FF2626, #FF9393)',
  },
  INFO: {
    DEFAULT: 'light-dark(#1F69FF, #8FB4FF)',
    SOFT: 'light-dark(#4C87FF, #6D9EFF)',
    MUTED: 'light-dark(#8FB4FF, #4C87FF)',
    HOVER: 'light-dark(#1A59D9, #C7DAFF)',
    ACTIVE: 'light-dark(#164AB3, #E9F0FF)',
    ON_INFO: 'light-dark(#FFFFFF, #0B2559)',
    CONTAINER_DEFAULT: 'light-dark(#1F69FF1A, #4C87FF33)',
    CONTAINER_SOFT: 'light-dark(#1F69FF0D, #4C87FF1A)',
    CONTAINER_MUTED: 'light-dark(#1F69FF08, #4C87FF0D)',
    CONTAINER_HOVER: 'light-dark(#1F69FF33, #4C87FF4D)',
    CONTAINER_ACTIVE: 'light-dark(#1F69FF4D, #4C87FF66)',
    ON_CONTAINER: 'light-dark(#1F69FF, #8FB4FF)',
  },
  STATUS_01: {
    DEFAULT: 'light-dark(#7700FF, #BB80FF)',
    SOFT: 'light-dark(#9233FF, #A759FF)',
    MUTED: 'light-dark(#BB80FF, #9233FF)',
    HOVER: 'light-dark(#6500D9, #DDBFFF)',
    ACTIVE: 'light-dark(#5300B3, #F1E6FF)',
    ON_STATUS_01: 'light-dark(#FFFFFF, #2A0059)',
    CONTAINER_DEFAULT: 'light-dark(#7700FF1A, #9233FF33)',
    CONTAINER_SOFT: 'light-dark(#7700FF0D, #9233FF1A)',
    CONTAINER_MUTED: 'light-dark(#7700FF08, #9233FF0D)',
    CONTAINER_HOVER: 'light-dark(#7700FF33, #9233FF4D)',
    CONTAINER_ACTIVE: 'light-dark(#7700FF4D, #9233FF66)',
    ON_CONTAINER: 'light-dark(#7700FF, #BB80FF)',
  },
  STATUS_02: {
    DEFAULT: 'light-dark(#4055E8, #A0AAF3)',
    SOFT: 'light-dark(#6677ED, #8391F0)',
    MUTED: 'light-dark(#A0AAF3, #6677ED)',
    HOVER: 'light-dark(#3648C5, #CFD4F9)',
    ACTIVE: 'light-dark(#2D3CA2, #ECEEFD)',
    ON_STATUS_02: 'light-dark(#FFFFFF, #161E51)',
    CONTAINER_DEFAULT: 'light-dark(#4055E81A, #6677ED33)',
    CONTAINER_SOFT: 'light-dark(#4055E80D, #6677ED1A)',
    CONTAINER_MUTED: 'light-dark(#4055E808, #6677ED0D)',
    CONTAINER_HOVER: 'light-dark(#4055E833, #6677ED4D)',
    CONTAINER_ACTIVE: 'light-dark(#4055E84D, #6677ED66)',
    ON_CONTAINER: 'light-dark(#4055E8, #A0AAF3)',
  },
  STATUS_03: {
    DEFAULT: 'light-dark(#038FDE, #81C7EF)',
    SOFT: 'light-dark(#35A5E5, #5BB6EA)',
    MUTED: 'light-dark(#81C7EF, #35A5E5)',
    HOVER: 'light-dark(#037ABD, #C0E3F7)',
    ACTIVE: 'light-dark(#02649B, #E6F4FC)',
    ON_STATUS_02: 'light-dark(#FFFFFF, #01324E)',
    CONTAINER_DEFAULT: 'light-dark(#038FDE1A, #35A5E533)',
    CONTAINER_SOFT: 'light-dark(#038FDE0D, #35A5E51A)',
    CONTAINER_MUTED: 'light-dark(#038FDE08, #35A5E50D)',
    CONTAINER_HOVER: 'light-dark(#038FDE33, #35A5E54D)',
    CONTAINER_ACTIVE: 'light-dark(#038FDE4D, #35A5E566)',
    ON_CONTAINER: 'light-dark(#038FDE, #81C7EF)',
  },
  STATUS_04: {
    DEFAULT: 'light-dark(#1898A9, #8CCCD4)',
    SOFT: 'light-dark(#46ADBA, #69BCC7)',
    MUTED: 'light-dark(#8CCCD4, #46ADBA)',
    HOVER: 'light-dark(#148190, #C5E5EA)',
    ACTIVE: 'light-dark(#116A76, #E8F5F6)',
    ON_STATUS_02: 'light-dark(#FFFFFF, #08353B)',
    CONTAINER_DEFAULT: 'light-dark(#1898A91A, #46ADBA33)',
    CONTAINER_SOFT: 'light-dark(#1898A90D, #46ADBA1A)',
    CONTAINER_MUTED: 'light-dark(#1898A908, #46ADBA0D)',
    CONTAINER_HOVER: 'light-dark(#1898A933, #46ADBA4D)',
    CONTAINER_ACTIVE: 'light-dark(#1898A94D, #46ADBA66)',
    ON_CONTAINER: 'light-dark(#1898A9, #1898A9)',
  },
  STATUS_05: {
    DEFAULT: 'light-dark(#CA20D9, #E490EC)',
    SOFT: 'light-dark(#D54DE1, #DD6EE6)',
    MUTED: 'light-dark(#E490EC, #D54DE1)',
    HOVER: 'light-dark(#AC1BB8, #F2C7F6)',
    ACTIVE: 'light-dark(#8D1698, #FAE9FB)',
    ON_STATUS_02: 'light-dark(#FFFFFF, #470B4C)',
    CONTAINER_DEFAULT: 'light-dark(#CA20D91A, #D54DE133)',
    CONTAINER_SOFT: 'light-dark(#CA20D90D, #D54DE11A)',
    CONTAINER_MUTED: 'light-dark(#CA20D908, #D54DE10D)',
    CONTAINER_HOVER: 'light-dark(#CA20D933, #D54DE14D)',
    CONTAINER_ACTIVE: 'light-dark(#CA20D94D, #D54DE166)',
    ON_CONTAINER: 'light-dark(#CA20D9, #E490EC)',
  },
  STATUS_06: {
    DEFAULT: 'light-dark(#D9206F, #EC90B7)',
    SOFT: 'light-dark(#E14D8C, #E66EA1)',
    MUTED: 'light-dark(#EC90B7, #E14D8C)',
    HOVER: 'light-dark(#B81B5E, #F6C7DB)',
    ACTIVE: 'light-dark(#98164E, #FBE9F1)',
    ON_STATUS_02: 'light-dark(#FFFFFF, #4C0B27)',
    CONTAINER_DEFAULT: 'light-dark(#D9206F1A, #E14D8C33)',
    CONTAINER_SOFT: 'light-dark(#D9206F0D, #E14D8C1A)',
    CONTAINER_MUTED: 'light-dark(#D9206F08, #E14D8C0D)',
    CONTAINER_HOVER: 'light-dark(#D9206F33, #E14D8C4D)',
    CONTAINER_ACTIVE: 'light-dark(#D9206F4D, #E14D8C66)',
    ON_CONTAINER: 'light-dark(#D9206F, #EC90B7)',
  },
  STATIC: {
    WHITE: '#FFFFFF',
    BLACK: '#000000'
  }
}